"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const i18n_1 = __importDefault(require("@yandex-int/pythia-libs/lib/i18n"));
// import {Attachment, StatusProps} from '../types';
const attachment_video_with_timer_1 = __importDefault(require("../attachment-video-with-timer"));
const attachment_image_1 = __importDefault(require("../attachment-image"));
const container_with_timer_1 = __importDefault(require("../container-with-timer"));
const types_1 = require("../types");
const i18n = (0, i18n_1.default)(['attach', 'image']);
/* interface AttachmentWithTimerProps extends StatusProps {
    value: Attachment;
    timeLimit: number;
    timeLimitType: TimeLimitType;
} */
const AttachmentWithTimerComponent = props => {
    const { value } = props, rest = __rest(props, ["value"]);
    const { timeLimitType } = rest;
    const curtainImageDesc = {
        [types_1.TimeLimitType.NOT_MORE]: i18n(['notMore']),
        [types_1.TimeLimitType.NOT_LESS]: i18n(['notLess'])
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [value.type === 'image' && ((0, jsx_runtime_1.jsx)(container_with_timer_1.default, Object.assign({}, rest, { tpl: curtainImageDesc[timeLimitType] }, { children: (0, jsx_runtime_1.jsx)(attachment_image_1.default, { url: value.url }) }))), value.type === 'video' && (0, jsx_runtime_1.jsx)(attachment_video_with_timer_1.default, Object.assign({ value: value }, rest))] }));
};
exports.default = AttachmentWithTimerComponent;
